/**
 * Controls the NextJS router cache on clients
 */ export var NEXTJS_ROUTER_CACHE_250124 = 'NEXTJS_ROUTER_CACHE_250124';
